import { ListItem } from '../../../../shared/ui/index.js';
import type { OccurrenceMark } from '../../model/occurrence-mark.js';

type OccurrenceRowAction = {
  label: string;
  onSelect: () => void;
};

type OccurrenceRowProps = {
  title: string;
  value?: string;
  mark: OccurrenceMark | null;
  meta?: string;
  valueNote?: string;
  onClick: () => void;
  /** A button in the row itself, so the usual next step takes one tap instead of a sheet. */
  action?: OccurrenceRowAction;
};

export const OccurrenceRow = ({
  title,
  value,
  mark,
  meta,
  valueNote,
  onClick,
  action,
}: OccurrenceRowProps) => (
  <ListItem
    title={title}
    subtitle={meta}
    note={mark ?? undefined}
    isSecondLineWrapping
    value={value}
    valueNote={valueNote}
    chevron={action === undefined}
    onClick={onClick}
    action={action}
  />
);
